const locale = {
  APPLICATIONS: "Applications",
  EXAMPLE: "Example",
  USER_MANAGEMENT: "User Management",
  BRANCHES: "Locations",
  ROOMS: "Rooms",
  DEVICES: "Devices",
  REPORTS: "Reports",
  BEDS: "Beds",
  DASHBOARD: "Dashboard",
  INTERNET_POLICIES: "Internet Access",
  GUEST_USER_ACCESS: "Guest User Access",
  VIP_ACCESS: "VIP Access",
  STUDENT_ACCESS: "Student Access",
  DORMS: "Parents/Guest",
  STAFF: "Staff",
  IOT: "IOT",
  PRIVATE_USER_ACCESS: "Private User",
  VOUCHERS: "Vouchers",
  USER_DATABASE: "User Database",
  REGISTERED_USERS: "Registered Users",
  TEMPORARY_USERS: "Temporary User",
  HARDWARE: "Hardware",
  MONITERING: "Monitoring",
  PORTS: "Ports",
  GATEWAYS: "Gateway",
  REPORTS: "Reports",
  SETTINGS: "Settings",
  GENERAL_SETTINGS: "General Settings",
  LOCATION_INFORMATION: "Account information",
  ADMINISTRATORS: "Administrators",
  BILLING_DETAILS: "Billing details",
  NETWORK_SETTINGS: "Network Settings",
  INSTITUTIONS: "Institutions",
  AUTHENTICATION_OPTION: "Authentication options",
  REGISTER_MAC: "Register Mac",
  WIFI_SSID: "Wi-Fi SSID",
  BRANCHES: "Branches",
  SURFING_POLICIES: "Surfing Policies",
  GATEWAYS_SETTINGS: "Gateways",
  ADVANCED_SETTINGS: "Advanced Settings",
  DHCP: "DHCP",
  DHCP_CLIENTS: "DHCP Clients",
  RESERVED_CLIENTS: "Reserved Clients",
  PORT_FORWARDING: "Port Forwarding",
  WEB_FILTERS: "Web Filters",
  ALARM_LOGS: "Alarm Logs",
  PAID_WIFI: "Paid Wifi",
  EMPLOYEE: "Employee",
  DOCTOR: "Doctors",
  FACULTYADMIN: "Faculty/Admin User",
  PERSONAL_ACCESS: "Personal Access",
  REGULAR_VISITORS: "Regular Visitors",
  GET_REVIEWS: "Get Reviews",
  REVIEWS: "Reviews",
  REVIEW_LINK: "Review Link",
  ANALYTICS: "Analytics",
  AUTOMATE: "Automate",
  TEMPLATES: "Templates",
  SOCIAL: "Social",
  NOTIFICATIONS: "Notifications",
  DASH: "Dashboard",
  INTEGRATION: "Integration",
  WIDGETS: "Widgets",
  LOGOUT: "Logout",
  DSH: "Dashboard",
  USER_DATABASES: "User Database",
  PROCESSING: "Processing",
  ANALYTIC: "Analytic",
  FACEIDSETTINGS: "Settings",
  CONFIGURATION: "Configuration",
  NOTIFICATION: "Notification",
  LIVE_CDR: "Live CDR",
  DID_MASTER: "DID Master",
  VIRTUAL_NO_MAPPING: "Virtual No Mapping",
  REVIEWS_AND_RATINGS: "Reviews & Ratings",
  LOCATION_WISE_GRAPH: "Location Wise Graph",
  REVIEWS_DISTRIBUTION_BY_EMPLOYEE: "Reviews Distribution",
  RESPONSIVE_TIME_OVER_TIME : "Response Time",
  LEADERBOARD: "Leaderboard",
  RESPONSE_TIME_DISTRIBUTION: "Response Time Distribution",
  EMPLOYEE_MASTER: "Employee Master",
  RESPONSE_RATE_BY_CITY: "Response Rate By City",
  REVIEW_NPS_BY_LOCATION: "Review NPS By Location",
  PERFORMANCE_BY_LOCATION: "Performnce By Location",
  CUSTOM: "Custom",
  DS: "Dashboard",
  ANALYTICS_REPORTS:"Analytics",
  ANALYTICS_PORTAL:"Analytics",
  ANALYTICS_FACEID:"Analytics",
  ANALYTICS_CONNECT:"Analytics",
  CONNECT_USER_DATABASE: "User Database",
  VENDOR: "Vendor",
  LOCATION: "Location",
  AGENTS: "Agents",
  KNOWLEDGE_BASE: "Knowledge Base",
  CONVERSATIONS: "Conversations",
};

export default locale;
